export const DEFAULT_API_URL = process.env.DEFAULT_API_URL || '';
export const EXAMPLE_SPECS = [
    {
        text: 'Share Of Model',
        value: 'https://openapi.shareofmodel.ai/swagger.json',
    },
    {
        text: 'Share Of Model (Search Module)',
        value: 'https://openapi.shareofmodel.ai/swagger-sos.json',
    },
];
